import { useQuery, useMutation, useQueryClient } from 'react-query';
import apiCalls from '../../utils/apiCalls';

export function useBusinessProfile({ businessProfileId, onSuccess }) {
  const { data, ...rest } = useQuery(
    'businessProfile',
    () =>
      apiCalls.getBusinessProfiles({ businessProfileId }).then(({ data: { businessProfiles } }) => businessProfiles[0]),
    {
      onSuccess: (data) => {
        onSuccess(data);
      },
    }
  );
  return { businessProfile: data, ...rest };
}

export function useBusinessProfiles(params) {
  const { data, ...rest } = useQuery('businessProfiles', () =>
    apiCalls.getBusinessProfiles(params).then(({ data: { businessProfiles, totalCount } }) => ({
      businessProfiles,
      totalCount,
    }))
  );
  return { result: data, ...rest };
}

export function useBusinessProfileEdit(onSuccess) {
  const queryClient = useQueryClient();
  const { mutate, ...rest } = useMutation(({ businessProfile }) => apiCalls.editBusinessProfile({ businessProfile }), {
    onSuccess: (ddm) => {
      queryClient.invalidateQueries('businessProfiles');
      onSuccess(ddm);
    },
  });
  return { editBusinessProfile: mutate, ...rest };
}

export function useServiceAreas() {
  const { data, ...rest } = useQuery(['serviceAreas'], () =>
    apiCalls.getServiceAreas().then(({ data: { serviceAreas } }) => serviceAreas)
  );
  return { serviceAreas: data, ...rest };
}
